import React from 'react'

import { HighlightedEmployerName } from '@frame/ui-components/highlighted-employer-name'
import { Button } from '@frame/ui-primitives/button'
import { Card } from '@frame/ui-primitives/card'
import { H4 } from '@frame/ui-primitives/h4'
import { P } from '@frame/ui-primitives/p'

import { DirectTask } from '@frame/lib/api/tasks/types'
import { DataAttribute } from '@frame/types'

type Props = {
  task: DirectTask
  handleVerify: (task: DirectTask, index?: number) => void
  isTenantVerifier?: boolean
}

export function EmployerHistoryCard({ task, handleVerify, isTenantVerifier }: Props) {
  const employerName = task?.employer_name || 'Employer'

  return (
    <Card data-cy={DataAttribute.EMPLOYER_HISTORY_CARD} intent="secondary" className="flex flex-col p-4">
      {isTenantVerifier ? (
        <H4 as="div">
          I receive paychecks from a single employer: <HighlightedEmployerName employerName={employerName} />
        </H4>
      ) : (
        <>
          <H4 as="div">Connect payroll</H4>
          <P variant="small" className="mt-2">
            Securely log into your employer’s payroll provider.
          </P>
        </>
      )}
      <Button applyCobranding intent="tertiary" onClick={() => handleVerify(task)} className="mt-4">
        Provide employment details
      </Button>
    </Card>
  )
}
